"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    details: {
      display: 'block',
      padding: '0',
      borderTop: '1px solid #ccc',
      borderBottom: '1px solid #ccc'
    },
    actions: {
      padding: '8px'
    }
  };
});
exports.useStyles = useStyles;